import request from '@/utils/request'

const DistributionApi = {
  promoteSettingDetail(errorback) {
    return request._get('/shop/distribution.PromoteSetting/index', {}, errorback)
  },
  promoteSettingSave(data, errorback) {
    return request._post('/shop/distribution.PromoteSetting/index', data, errorback)
  },
  promoteOrderList(data, errorback) {
    return request._post('/shop/distribution.PromoteOrder/index', data, errorback)
  },
  refereeBindLogList(data, errorback) {
    return request._post('/shop/distribution.RefereeBindLog/index', data, errorback)
  }
}

export default DistributionApi



// WEBPACK FOOTER //
// ./src/api/distribution.js